import * as React from 'react'
import * as ReactHighcharts from 'react-highcharts'
import { Panel } from 'react-bootstrap';
import { IFilter, IPeerGroupTabsProps, IVisualizationState, round, roundNumber } from '../lib/http';
import { AssetAllocationByStrategy } from './AssetAllocationByStrategy'


class AssetAllocationIndividual extends React.Component<IPeerGroupTabsProps, IVisualizationState> {
  state: IVisualizationState = {
    categories: [],
    data: [],
    series: [],
    filters: { assetLevel: -1 },
    title: '',
    loading: false,
    average: [],
    plotLineNumber: 0,
  }

  componentDidMount() {
    this.setState({ data: this.props.data }, () => this.loadSeries(this.props.filters))
  }

  componentDidUpdate(prevProps) {
    if (prevProps.filters.assetLevel !== this.props.filters.assetLevel || prevProps.data.length !== this.props.data.length) {
      this.setState({ filters: this.props.filters, data: this.props.data }, () => {
        this.loadSeries(this.props.filters)
      })
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state

    const currentSet = data.find(dataPoint => dataPoint.filterId === filters.assetLevel)

    if (!currentSet) return

    const title = currentSet ? currentSet['Strat_T_V22_Vis22Title'] : ''
    const seriesData = [{ color: '#D9D9D9', name: currentSet['Strat_T_V22_CashLabel'], y: currentSet['Strat_N_V22_CashTotal'] },
    { color: '#AEAAAA', name: currentSet['Strat_T_V22_FixedLabel'], y: currentSet['Strat_N_V22_FixedTotal'] },
    { color: '#A9D08E', name: currentSet['Strat_T_V22_EquityLabel'], y: currentSet['Strat_N_V22_EquityTotal'] },
    { color: '#BDD7EE', name: currentSet['Strat_T_V22_InvOthLabel'], y: currentSet['Strat_N_V22_InvOthTotal'] },
    { color: '#D5B8EA', name: currentSet['Strat_T_V22_OthAssetLabel'], y: currentSet['Strat_N_V22_OthAssetsTotal'] }]

    const series = [{ name: currentSet['IncCon_T_B_IncomingPercent'], data: seriesData }]

    this.setState({ title, series, })

  }

  getChartConfig(series) {
    const title = ''
    return {
      chart: { type: 'pie' },
      title: {
        text: title
      },
      yAxis: {
        visible: true,
        opposite: true,
        title: '',
        labels: {
          format: '{value}%',
        },
      },
      plotOptions: {
        column: {
          stacking: 'normal',
          dataLabels: {
            enabled: true,
            format: '{y}%'
          },
        }
      },
      legend: { enabled: true },
      credits: { enabled: false },
      tooltip: { enabled: false },
      series
    }
  }

  render() {
    const { title, series, categories, loading } = this.state
    return (
      <Panel>
        <div className="panel-heading text-center">
          {title}{loading && <i className="fa fa-cog fa-spin"></i>}
        </div>
        <div className="panel-body">
          <ReactHighcharts config={this.getChartConfig(series)} ref="chart" />
        </div>
      </Panel>
    )
  }
}

export default AssetAllocationIndividual;


// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/AssetAllocation/AssetAllocationIndividual.tsx